// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KdKz","type":"styles_type__35GTk","choices":"styles_choices__2e-nL"};